const Podcast = {
    
    // note - lightbox binding occurs in lightbox.js - this script only handles 
    // replacing the player H3 when a valid value has been provided via the admin
    
    init()
	{
        const podcastPlayers = document.querySelectorAll('.js-podcast');
        
        if( podcastPlayers )
        {
            Array.prototype.forEach.call( podcastPlayers, player => {
                const playerAltTitle = player.getAttribute('data-alt-title');

                if( playerAltTitle )
                {
                    const titleH3 = player.querySelector('h3');
                    if( titleH3 )
                    {
                        titleH3.innerHTML = playerAltTitle;
                    }
                }

                player.classList.add('ready');
            });
        }
	}
};

export default Podcast;